
document.addEventListener( 'DOMContentLoaded', function () {
	const carousels = document.querySelectorAll( '.logo-carousel' );

	carousels.forEach( ( carousel ) => {
		const track = carousel.querySelector( '.logo-carousel__track' );
		const duration = carousel.getAttribute( 'data-animation-duration' ) || 30;

		track.style.setProperty( '--animation-duration', `${ duration }s` );
	} );
} );
